import React from "react";
import { Icon, UserAvatar } from "../../components/Component";
import { Link } from "react-router-dom";

const WorkBoqAside = ({ updateSm, sm }: any) => {
  return (
    <div className="card-inner-group" style={{ minHeight: "90vh" }}>
      <div className="card-inner">
        <div className="user-card">
          {/* <UserAvatar size="lg" theme="primary" text="WB" /> */}
          <div className="user-info">
            <span className="lead-text">Work BOQ</span>
            <span className="sub-text">Bill of Quantities for Work Orders</span>
          </div>
          {/* <div className="user-action">
            <div className="dropdown">
              <a
                href="#"
                className={`btn btn-icon btn-trigger mr-n2 ${
                  sm ? "active" : ""
                }`}
                onClick={(ev) => {
                  ev.preventDefault();
                  updateSm(!sm);
                }}
              >
                <Icon name="more-v" />
              </a>
            </div>
          </div> */}
        </div>
      </div>
      {/* <div className="card-inner">
        <div className="user-account-info py-0">
          <h6 className="overline-title-alt">Work BOQ Management</h6>
          <div className="user-balance">
            <div className="user-balance-sub">
              <Icon name="briefcase" />
              <span>Create and manage work scope definitions</span>
            </div>
          </div>
        </div>
      </div> */}
      <div className="card-inner p-0">
        <ul className="link-list-menu">
          <li>
            <Link
              to={`${process.env.PUBLIC_URL}/work-boq-creation`}
              onClick={() => updateSm(false)}
            >
              <Icon name="plus-round-fill" />
              <span>Create New Work BOQ</span>
            </Link>
          </li>
          <li>
            <Link
              to={`${process.env.PUBLIC_URL}/work-boq-list`}
              onClick={() => updateSm(false)}
            >
              <Icon name="list-fill" />
              <span>View Work BOQ List</span>
            </Link>
          </li>
          <li>
            <Link
              to={`${process.env.PUBLIC_URL}/work-boq-approvals`}
              onClick={() => updateSm(false)}
            >
              <Icon name="check-circle-fill" />
              <span>Work BOQ Approvals</span>
            </Link>
          </li>
          <li>
            <Link
              to={`${process.env.PUBLIC_URL}/work-boq-reports`}
              onClick={() => updateSm(false)}
            >
              <Icon name="reports" />
              <span>Work BOQ Reports</span>
            </Link>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default WorkBoqAside;